<div *ngIf="visitanteInfoForm && !cargando" class="detalle-visitante-container">
  
  <!-- HEADER -->
  <header class="detalle-header">
    <div class="header-left">
      <h1 class="header-title">Información del Visitante</h1>
      <span class="header-subtitle" *ngIf="visitanteInfoForm.get('hour_checkin')?.value">
        {{visitanteInfoForm.get('hour_checkin')?.value}}
      </span>
    </div>
    <div class="header-right">
      <div class="status-info">
        <div class="status-label">Estado</div>
        <div class="status-value" [class.status-preaprobado]="statusName === 'Pre-aprobado'">
          {{statusName || '--'}}
        </div>
      </div>
      <div class="badge-role" [class.badge-visitante]="typeUser === 'V'" [class.badge-contratista]="typeUser === 'C'" [class.badge-proveedor]="typeUser === 'P'">
        {{getTipoTerceroNombre(typeUser).toUpperCase()}}
      </div>
    </div>
  </header>

  <!-- MAIN CONTENT (Grid Layout) -->
  <main class="detalle-main">
    
    <!-- COL 1: EVIDENCIA (Foto y Vehículo) -->
    <div class="col-evidencia">
      <!-- Foto/Selfie -->
      <div class="panel-foto">
        <div class="foto-badge">📷 FOTO</div>
        <img 
          *ngIf="selfieUrl && selfieUrl !== '' && !selfieError" 
          [src]="selfieUrl" 
          class="foto-selfie" 
          alt="Selfie del visitante"
          (error)="selfieError = true">
        <div class="foto-placeholder" *ngIf="!selfieUrl || selfieUrl === '' || selfieError">
          <span>Sin foto disponible</span>
        </div>
        <div class="foto-overlay">
          <div class="foto-name">{{visitanteInfoForm.get('name')?.value || '--'}}</div>
          <div class="foto-doc">{{visitanteInfoForm.get('number_document')?.value || '--'}}</div>
        </div>
      </div>

      <!-- Vehículo (si existe) -->
      <div class="panel-vehiculo" *ngIf="visitanteInfoForm.get('type_vehicle')?.value && visitanteInfoForm.get('type_vehicle')?.value !== '0' && visitanteInfoForm.get('type_vehicle')?.value !== '-'">
        <div class="panel-title">🚗 Vehículo</div>
        <div class="vehiculo-content">
          <div class="placa-box" *ngIf="visitanteInfoForm.get('plate_vehicle')?.value && visitanteInfoForm.get('plate_vehicle')?.value !== '-'">
            <div class="placa-header">COL</div>
            <div class="placa-number">{{visitanteInfoForm.get('plate_vehicle')?.value}}</div>
          </div>
          <div class="vehiculo-info">
            <div class="vehiculo-marca">{{visitanteInfoForm.get('brand_vehicle')?.value || '--'}}</div>
            <div class="vehiculo-tipo">{{visitanteInfoForm.get('type_vehicle')?.value}}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- COL 2: DATOS PERSONALES Y CONTEXTO -->
    <div class="col-datos">
      
      <!-- Contexto de Visita -->
      <div class="panel panel-contexto">
        <div class="panel-title">📍 Contexto de Visita</div>
        <div class="contexto-grid">
          <div class="data-card">
            <span class="data-label">Destino</span>
            <span class="data-value">{{visitanteInfoForm.get('apartamento')?.value || '--'}}</span>
          </div>
          <div class="data-card data-card-highlight">
            <span class="data-label">Autoriza</span>
            <span class="data-value">{{visitanteInfoForm.get('aut_name')?.value || '--'}}</span>
          </div>
          <div class="data-card data-card-full">
            <span class="data-label">Área</span>
            <span class="data-value">{{visitanteInfoForm.get('area')?.value || '--'}}</span>
          </div>
          <div class="data-card data-card-full" *ngIf="visitanteInfoForm.get('note')?.value && visitanteInfoForm.get('note')?.value !== '-'">
            <span class="data-label">Nota / Comentario</span>
            <span class="data-value data-value-note">{{visitanteInfoForm.get('note')?.value}}</span>
          </div>
        </div>
      </div>

      <!-- Datos Personales -->
      <div class="panel panel-personales">
        <div class="panel-title">👤 Datos Personales</div>
        <div class="personales-grid">
          <div class="data-card">
            <span class="data-label">Nombre</span>
            <span class="data-value">{{visitanteInfoForm.get('name')?.value || '--'}}</span>
          </div>
          <div class="data-card">
            <span class="data-label">Documento</span>
            <span class="data-value data-value-mono">
              {{visitanteInfoForm.get('type_document')?.value}} {{visitanteInfoForm.get('number_document')?.value}}
            </span>
          </div>
          <div class="data-card" *ngIf="visitanteInfoForm.get('phone')?.value">
            <span class="data-label">Teléfono</span>
            <span class="data-value">
              {{visitanteInfoForm.get('indicative')?.value || ''}} {{visitanteInfoForm.get('phone')?.value || '--'}}
            </span>
          </div>
          <div class="data-card">
            <span class="data-label">Fecha y Hora Llegada</span>
            <span class="data-value">{{visitanteInfoForm.get('hour_checkin')?.value || '--'}}</span>
          </div>
          <div class="data-card">
            <span class="data-label">Fecha y Hora Salida</span>
            <span class="data-value">{{visitanteInfoForm.get('hour_checkout')?.value || '--'}}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- COL 3: PROTOCOLO DE SEGURIDAD -->
    <div class="col-seguridad">
      <div class="panel-seguridad-header">
        <span class="seguridad-icon">🛡️</span>
        <div class="seguridad-title">Protocolo de Seguridad</div>
      </div>

      <div class="protocolo-list">
        <!-- Check 1: Rostro -->
        <div class="protocolo-item" [class.checked]="checkRostro" (click)="toggleCheckRostro()">
          <div class="protocolo-check">
            <div class="check-circle" [class.checked]="checkRostro">✓</div>
          </div>
          <div class="protocolo-content">
            <div class="protocolo-title">Rostro Coincide</div>
            <div class="protocolo-desc">Verifique rasgos con foto en vivo</div>
          </div>
        </div>

        <!-- Check 2: Documento -->
        <div class="protocolo-item" [class.checked]="checkDocumento" (click)="toggleCheckDocumento()">
          <div class="protocolo-check">
            <div class="check-circle" [class.checked]="checkDocumento">✓</div>
          </div>
          <div class="protocolo-content">
            <div class="protocolo-title">Documento Físico</div>
            <div class="protocolo-desc">
              Coincide con {{visitanteInfoForm.get('number_document')?.value || 'datos'}}
            </div>
          </div>
        </div>

        <!-- Check 3: Vehículo (si aplica) -->
        <div class="protocolo-item" 
             *ngIf="visitanteInfoForm.get('type_vehicle')?.value && visitanteInfoForm.get('type_vehicle')?.value !== '0' && visitanteInfoForm.get('type_vehicle')?.value !== '-'"
             [class.checked]="checkVehiculo" 
             (click)="toggleCheckVehiculo()">
          <div class="protocolo-check">
            <div class="check-circle" [class.checked]="checkVehiculo">✓</div>
          </div>
          <div class="protocolo-content">
            <div class="protocolo-title">Vehículo Coincide</div>
            <div class="protocolo-desc" *ngIf="visitanteInfoForm.get('plate_vehicle')?.value && visitanteInfoForm.get('plate_vehicle')?.value !== '-'">
              Placa: {{visitanteInfoForm.get('plate_vehicle')?.value}}
            </div>
            <div class="protocolo-desc" *ngIf="!visitanteInfoForm.get('plate_vehicle')?.value || visitanteInfoForm.get('plate_vehicle')?.value === '-'">
              Placa y características
            </div>
          </div>
        </div>
      </div>
    </div>

  </main>

  <!-- BOTONES DE ACCIÓN -->
  <div class="detalle-actions" *ngIf="!editable">
    <app-botones-cambios 
      *ngIf="visitanteInfoForm.get('status')?.value === TIPOS_VISITAS.PENDIENTE" 
      [mostrar]="true" 
      [ocultarBotonSecundario]="true" 
      [textoBotonPrincipal]="'Registrar Ingreso'" 
      [deshabilitado]="!estaActivo"
      (onGuardar)="registrarVisitante()">
    </app-botones-cambios>
  </div>

</div>

<!-- FORMULARIO EDITABLE (solo cuando editable = true) -->
<form *ngIf="visitanteInfoForm && editable" [formGroup]="visitanteInfoForm" class="contenedor-visitante">
    <div class="informacion-inicio">
        <div>
            <label for="">Área</label>
            <mat-select 
                formControlName="area"
                placeholder="Seleccione"
                [class.required]="area.invalid && area.touched"
                >
                <mat-option *ngFor="let area of areas;" [value]="area">
                    {{area.descripcion}}
                </mat-option>
            </mat-select>
        </div>

        <div>
            <label for="">Unidad</label>
            <mat-select
                formControlName="place_id"
                placeholder="Seleccione"
                [class.required]="area.value && place_id?.invalid && place_id?.touched"
                >
                <mat-option *ngFor="let apartamento of apartamentos;" [value]="apartamento.id">
                    {{apartamento.site_name}}
                </mat-option>
            </mat-select>
        </div>

        <div>
            <label for="">Autorizado por</label>
            <mat-select
                formControlName="user_id"
                placeholder="Seleccione"
                [class.required]="place_id.value && user_id?.invalid && user_id?.touched"
                >
                <mat-option *ngFor="let miembro of miembros;" [value]="miembro.id">
                    {{miembro.name}}
                </mat-option>
            </mat-select>
        </div>
    </div>
    <hr>
    <div class="informacion-medio">
        <div>
            <label for="">Nombre visitante</label>
            <input
                formControlName="name"
                type="text"
                placeholder="Nombre visitante"
                [class.required]="name.invalid && name.touched"
                >
        </div>
        <div>
            <label for="">Tipo de documento</label>
            <mat-select
                formControlName="type_document"
                placeholder="Seleccione"
                [class.required]="type_document.invalid && type_document.touched"
                >
                <mat-option *ngFor="let tipoDocumento of tiposDeDocumentos;" [value]="tipoDocumento">
                    {{tipoDocumento}}
                </mat-option>
            </mat-select>
        </div>
        <div>
            <label for="">Número identificación</label>
            <input
                formControlName="number_document"
                type="number"
                placeholder="Ingresar número"
                [class.required]="number_document.invalid && number_document.touched"
                >
        </div>
        <div class="indicativo-celular">
            <div>
                <label for="">Indicativo</label>
                <app-select-indicativo [indicativoForm]="visitanteInfoForm" [nombreCampo]="'indicative'"></app-select-indicativo>
            </div>
            <div>
                <label for="">Celular</label>
                <input
                    formControlName="phone"
                    type="number"
                    placeholder="Ingresar número"
                    [class.required]="phone.invalid && phone.touched"
                    >
            </div>
        </div>
        <div>
            <label for="">Fecha y hora llegada</label>
            <div class="contenedor-filtro-fecha" (click)="toggleMostrarCalendarioLlegada()">
                <div class="filtro-fecha">
                    {{fechaHoraLlegada.format('DD-MM-YYYY HH:mm a')}}
                    <mat-icon>calendar_today</mat-icon>
                </div>
                <app-calendario-mes [diaElegido]="fechaHoraLlegada" [mostrar]="seleccionarFechaHoraLlegada" style="right: 0;" (onFechaActualizada)="actualizarFechaHoraLlegada($event)"></app-calendario-mes>
            </div>
        </div>
        <div>
            <label for="">Fecha y hora salida</label>
            <div class="contenedor-filtro-fecha" (click)="toggleMostrarCalendarioSalida()" *ngIf="!fechaSalidaIndefinida">
                <div class="filtro-fecha">
                    {{fechaHoraSalida.format('DD-MM-YYYY HH:mm a')}}
                    <mat-icon>calendar_today</mat-icon>
                </div>
                <app-calendario-mes [diaElegido]="fechaHoraSalida" [mostrar]="seleccionarFechaHoraSalida" style="right: 0;" (onFechaActualizada)="actualizarFechaHoraSalida($event)"></app-calendario-mes>
            </div>
            <mat-checkbox
             [ngStyle]="{'margin-top': fechaSalidaIndefinida ? '5px' : '15px'}"
             [checked]="fechaSalidaIndefinida" (change)="cambiarFechaSalidaIndefinida($event)">Indefinida</mat-checkbox>
        </div>
    </div>
    <hr>
    <div class="informacion-fin">
        <div>
            <label for="">Tipo de vehículo</label>
            <mat-select formControlName="type_vehicle" placeholder="Seleccione vehículo">
                <mat-option *ngFor="let vehiculo of vehiculos;" [value]="vehiculo">
                    {{vehiculo}}
                </mat-option>
            </mat-select>
        </div>
        <div class="placa-marca">
            <div>
                <label for="">Placas</label>
                <input formControlName="plate_vehicle" type="text" maxlength="6" placeholder="Placa">
            </div>
            <div>
                <label for="">Marca</label>
                <input type="text" placeholder="Ingrese marca" [formControlName]="'mark'">
            </div>
        </div>
        <div>
            <label for="">Comentarios</label>
            <textarea formControlName="note" name="" placeholder="Ingresar comentario"></textarea>
        </div>
    </div>
</form>

<mat-spinner *ngIf="!visitanteInfoForm || cargando"></mat-spinner>

<app-botones-cambios *ngIf="editable" [mostrar]="visitanteInfoForm" (onGuardar)="crearVisitante()" (onCancelar)="volverAVisitantes()" style="margin-left: auto;"></app-botones-cambios>
